#import "../fragments/inbox-message-fragment.graphql"

mutation SendSharedInboxEmailMessage($input: MessageSendFromSharedInboxInput!) {
    messageSendFromSharedInbox(input: $input) {
        message {
            ...InboxMessageFragment
        }
    }
}
